// broadcast type bulk sms
export const TYPE_SMS = 1
// broadcast type bulk mms
export const TYPE_MMS = 2
// broadcast type ringless voicemail
export const TYPE_RVM = 3